module.exports = __webpack_public_path__ + "img/4.ea218b99.jpg";